export const IS_FORM_DIRTY = 'IS_FORM_DIRTY';
export const SHOW_CHICKEN_EXIT = 'SHOW_CHICKEN_EXIT';

const uri = '/api/xm/1/voice-recordings';

const VOICE_RECORDINGS_PAGE_DELETE_RECORDING =
  'VOICE_RECORDINGS_PAGE_DELETE_RECORDING';
export const deleteRecording = recordingId => {
  return {
    type: VOICE_RECORDINGS_PAGE_DELETE_RECORDING,
    meta: {
      xmApi: true,
      method: 'del',
      uri: `${uri}/${recordingId}`,
    },
  };
};

export const VOICE_RECORDINGS_PAGE_DELETE_RECORDINGS =
  'VOICE_RECORDINGS_PAGE_DELETE_RECORDINGS';
export const VOICE_RECORDINGS_PAGE_DELETE_RECORDINGS_START = `${VOICE_RECORDINGS_PAGE_DELETE_RECORDINGS}_START`;
export const VOICE_RECORDINGS_PAGE_DELETE_RECORDINGS_SUCCESS = `${VOICE_RECORDINGS_PAGE_DELETE_RECORDINGS}_SUCCESS`;
export const VOICE_RECORDINGS_PAGE_DELETE_RECORDINGS_FAIL = `${VOICE_RECORDINGS_PAGE_DELETE_RECORDINGS}_FAIL`;

export const deleteRecordings = recordingIds => dispatch => {
  const onSuccess = () =>
    dispatch({ type: VOICE_RECORDINGS_PAGE_DELETE_RECORDINGS_SUCCESS });

  const onFail = e => {
    dispatch({ type: VOICE_RECORDINGS_PAGE_DELETE_RECORDINGS_FAIL });
    throw e;
  };

  const handleNext = () => {
    return dispatch(deleteRecording(recordingIds.pop()))
      .then(() => (recordingIds.length ? handleNext() : onSuccess()))
      .catch(onFail);
  };
  dispatch({ type: VOICE_RECORDINGS_PAGE_DELETE_RECORDINGS_START });
  return handleNext();
};

export function setIsFormDirty(isDirty) {
  return {
    type: IS_FORM_DIRTY,
    payload: isDirty,
  };
}

export function setShowChickenExit(showChickenExit) {
  return {
    type: SHOW_CHICKEN_EXIT,
    payload: showChickenExit,
  };
}
